import * as actions from './actionTypes';
import axios from 'axios';
export const registerStart = () => {
  return {
    type: actions.REGISTER_START,
  }
}
export const registerFail = (error) => {
  return {
    type: actions.REGISTER_FAIL,
    error: error
  }
}
export const registerSuccess = (success) => {
  return {
    type: actions.REGISTER_SUCCESS,
    success: success
  }
}
export const register = (user) => {
  return (dispatch) => {
    dispatch(registerStart());
    const userData = user;
    console.log(userData);
    axios.post('http://13.234.61.196:2222/register', userData)
      .then((res) => {
        console.log(res);
        dispatch(registerSuccess(res.data));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response.data);
        dispatch(registerFail(err.response.data));
      });
  }
}

